export class RateLimitError extends Error {
  constructor(readonly url?: string) {
    super('Rate limited')
    this.name = 'RateLimitError'
  }
}

export const isRateLimitError = (error: unknown): error is RateLimitError =>
  error instanceof RateLimitError
